import { render, staticRenderFns } from "./Third.vue?vue&type=template&id=635a0290&"
import script from "./Third.vue?vue&type=script&lang=js&"
export * from "./Third.vue?vue&type=script&lang=js&"
import style0 from "./Third.vue?vue&type=style&index=0&id=635a0290&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports